import React from "react";
import '../App.css'

const Input = ({
    bind = {},               // 상태 객체
    setBind = () => {},      // 상태 변경 함수
    id,                      // bind에서의 key
    onChange = () => {},     // 변경 시 실행할 콜백
    maxLength = 255,         // 최대 글자 수 제한
    textAlign = "left",      // 텍스트 정렬: left | center | right
    placeHolder = "",        // placeholder 텍스트
    allowChar = null,        // 입력 허용 정규식 (RegExp)
    width = "100%",          // 너비 (기본: 100, 단위 생략 시 px로 처리됨
    readOnly = false,        // 읽기 전용 여부
    type = "input",          // 기본값 input, 'textarea'면 textarea 렌더링
}) => {

    
    const bindKey = id;
    
    const handleChange = (e) => {
        let newValue = e.target.value;

        // 소문자 y/n 입력 시 자동 대문자 변환
        if (allowChar?.toString?.().includes('Y') && typeof newValue === "string") {
            newValue = newValue.toUpperCase();
        }

        // 정규식 검사
        if (allowChar && !allowChar.test(newValue)) {
            return;
        }

        // 상태 업데이트
        setBind(prev => ({
            ...prev,
            [bindKey]: newValue
        }));

        // 콜백 실행
        onChange({ id: bindKey, value: newValue });
    };

    // 정수 입력시 px로 대응하고 %나 auto등 문자열 입력시 대응
    const computedWidth =
        typeof width === "number"
            ? `${width}px`
            : /^[0-9]+$/.test(width)
            ? `${width}px`
            : width; // "200px", "50%", "auto" 등 문자열 단위 명시 시 그대로 적용

    // return될 태그에 입력될 파라미터
    const commonProps = {
        value: bind[bindKey] || "",
        onChange: handleChange,
        placeholder: placeHolder,
        maxLength: type === "date" ? undefined : maxLength, // 👍
        disabled: readOnly,
        style: {
            textAlign
            , width: computedWidth
            , backgroundColor: readOnly ? '#f5f5f5' : 'white'
            , color: readOnly ? '#999' : 'inherit'
        },
    };

    return type === "textarea" ? (
        <textarea className="custom-textarea" {...commonProps} rows={4} />
    ) : (
        <input type={type} className="custom-input" {...commonProps} />
    );
};

export default Input;
